(function () {

    'use strict';

    angular.module('iplusjs.api', [
        'lodash',
        'moment',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.format',
        'iplusjs.utils.binary'
    ])
    .config(config)
    .service('ApiService', ApiService)
    .service('ApiInterceptor', ApiInterceptor);

    config.$inject = [
        '$httpProvider',
        'AppConfigProvider'
    ];

    function config($httpProvider, AppConfigProvider) {
        var AppConfig = AppConfigProvider.$get(),
            _origTransformResponse = $httpProvider.defaults.transformResponse[0];
        $httpProvider.defaults.withCredentials = true;
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.headers.get.Pragma = 'no-cache';
        $httpProvider.defaults.transformResponse = function (response, headers) {
            var apiResponsePrefixRegExp = AppConfig.API.regexJsonResponsePrefix;

            if (angular.isString(response) && response.match(apiResponsePrefixRegExp)) {
                return angular.fromJson(response.match(apiResponsePrefixRegExp)[2]);
            }

            return _origTransformResponse(response, headers);
        };
    }

    ApiService.$inject = [
        '$log',
        '$injector',
        '$cacheFactory',
        '$q',
        'lodash',
        'moment',
        'AppConfig',
        'MiscUtilsService',
        'BinaryUtilsService',
        'AlertService'
    ];
    function ApiService($log, $injector, $cacheFactory, $q, _, moment, AppConfig, MiscUtilsService, BinaryUtilsService, AlertService) {
        var that = this,
            regexFilename = /(.*)\.(.*)/,
            regexFilenameContentDisposition = /filename="(.*)\.(.*)"/,
            regexIsHtmlPage = /\.html$|\.html\?/i,
            regexF5FirewallSupportId = /Your support ID is: ([0-9]*)/,
            cache = $cacheFactory('apiServiceCache'),
            HTTP_STATUS_OK = 200,
            HTTP_STATUS_BAD_REQUEST_ERROR = 400,
            HTTP_STATUS_INTERNAL_SERVER_ERROR = 500,
            HTTP_STATUS_VALIDATION_ERROR = 409,
            HTTP_STATUS_EXCLUDE_LIST = [401, 403];

        that.NACHRICHTEN_TYPES = {
            FEHLER: {
                wert: 'FEHLER',
                alertType: 'alert'
            },
            INFO: {
                wert: 'INFO',
                alertType: 'info'
            },
            WARNUNG: {
                wert: 'WARNUNG',
                alertType: 'warning'
            }
        };

        that.API_EXCEPTION_CAUSES = {
            ERROR: {
                wert: 'ERROR',
                alertType: 'alert'
            },
            FIREWALL: {
                wert: 'FIREWALL',
                alertType: 'alert'
            },
            VALIDATION_ERROR: {
                wert: 'VALIDATION_ERROR',
                alertType: 'alert'
            },
            VALIDATION_INFO: {
                wert: 'VALIDATION_INFO',
                alertType: 'info'
            },
            VALIDATION_WARNING: {
                wert: 'VALIDATION_WARNING',
                alertType: 'warning'
            }
        };

        that.getApiNachrichtenFromResponse = getApiNachrichtenFromResponse;
        that.getApiExceptionsFromResponse = getApiExceptionsFromResponse;
        that.isApiNachricht = isApiNachricht;
        that.getApiNachrichten = getApiNachrichten;
        that.getApiNachrichtenAsAlerts = getApiNachrichtenAsAlerts;
        that.getApiExceptionsAsAlerts = getApiExceptionsAsAlerts;
        that.getFileinfosFromHeader = getFileinfosFromHeader;
        that.hasErrors = hasErrors;
        that.getErrors = getErrors;
        that.setRequestTimeout = setRequestTimeout;
        that.isHtmlPage = isHtmlPage;
        that.isHttpError = isHttpError;
        that.isInternalServerError = isInternalServerError;
        that.isValidationError = isValidationError;
        that.isMaintenance = isMaintenance;
        function getApiNachrichtenFromResponse(response, type) {
            response = response || {};

            var data = _.isArrayBuffer(response.data) ? BinaryUtilsService.convertArrayBufferToJson(response.data) : response.data,
                apiNachrichten = _.get(data, 'nachrichten');

            if (!apiNachrichten && _.isArray(data)) {
                apiNachrichten = _.filter(data, function (obj) {
                    return obj.hasOwnProperty('art') && obj.hasOwnProperty('meldung');
                });
            }

            return getApiNachrichten(apiNachrichten, type);
        }
        function getApiExceptionsFromResponse(response) {
            response = response || {};

            var apiExceptions,
                returnVal,
                supportId,
                FormatUtilsService = $injector.get('FormatUtilsService');

            apiExceptions = _.isArrayBuffer(response.data) ? BinaryUtilsService.convertArrayBufferToJson(response.data) : response.data;

            if (_.isString(apiExceptions)) {
                supportId = (regexF5FirewallSupportId.exec(apiExceptions) || [])[1];

                if (supportId) {
                    returnVal = [{
                        message: FormatUtilsService.replace(AppConfig.MESSAGES.f5firewall, supportId),
                        cause: 'FIREWALL',
                        reason: 'FIREWALL'
                    }];
                }
            } else if (_.isArray(apiExceptions)) {
                returnVal = apiExceptions;
            } else {
                returnVal = [];
            }

            return returnVal;
        }
        function isApiNachricht(response) {
            var apiNachrichten = getApiNachrichtenFromResponse(response) || [];

            return !!apiNachrichten.length;
        }
        function getApiNachrichten(nachrichten, type) {
            if (MiscUtilsService.isEmpty(nachrichten)) {
                return [];
            }

            if (type) {
                return _.filter(nachrichten, {
                    art: type
                });
            }

            return nachrichten;
        }
        function getApiNachrichtenAsAlerts(nachrichten, ignoreErrors) {
            var alerts = [];

            ignoreErrors = ignoreErrors || {};
            if (ignoreErrors.nachrichten === true) {
                return [];
            }

            _.forEach(nachrichten, function (nachricht) {
                if (_.isArray(ignoreErrors.nachrichten) &&
                    _.includes(ignoreErrors.nachrichten, nachricht.art)
                ) {
                    return true;
                }

                alerts.push(AlertService.create(nachricht.meldung, that.NACHRICHTEN_TYPES[nachricht.art].alertType, false, nachricht.fehlercode, null, nachricht.kuerzel));
            });

            return alerts;
        }
        function getApiExceptionsAsAlerts(apiExceptions, ignoreErrors) {
            var alerts = [],
                message = '',
                FormatUtilsService = $injector.get('FormatUtilsService');

            ignoreErrors = ignoreErrors || {};
            if (ignoreErrors.errors === true && !_.find(apiExceptions, ['cause', that.API_EXCEPTION_CAUSES.FIREWALL.wert]) || _.isString(apiExceptions)) {
                return [];
            }

            _.forEach(apiExceptions, function (apiException) {
                if (ignoreErrors.errors &&
                    ((ignoreErrors.errors.cause && _.includes(ignoreErrors.errors.cause, apiException.cause)) ||
                    (ignoreErrors.errors.reason && _.includes(ignoreErrors.errors.reason, apiException.reason)))
                ) {
                    return true;
                }

                message = apiException.message || AppConfig.MESSAGES.unexpected;

                if (apiException.reason && _.get(AppConfig, 'MESSAGES.onlineAbschlussNichtMoeglich') && _.includes(['GESPERRT', 'ONLINEABSCHLUSS_NICHT_MOEGLICH'], apiException.reason)) {
                    message = FormatUtilsService.replace(_.get(AppConfig, 'MESSAGES.onlineAbschlussNichtMoeglich'), _.get(AppConfig, 'APP.telefon'), _.get(AppConfig, 'APP.urls.kontakt'));
                }

                alerts.push(AlertService.create(message, _.get(that.API_EXCEPTION_CAUSES, apiException.cause + '.alertType', 'alert'), false, apiException.fehlercode, null, apiException.reason || apiException.cause));
            });

            return alerts;
        }
        function getFileinfosFromHeader(str, headerKey) {
            var match,
                filename,
                extension;

            if (headerKey === 'content-disposition') {
                match = regexFilenameContentDisposition.exec(str);
            } else {
                match = regexFilename.exec(str);
            }

            if (_.isArray(match)) {
                filename = match[1] + '.' + match[2];
                extension = match[2];
            } else {
                return {};
            }

            return {
                filename: filename,
                extension: extension
            };
        }
        function hasErrors(response, ignoreErrors) {
            var apiErrors = getErrors(response, ignoreErrors);

            return !_.isEmpty(apiErrors);
        }
        function getErrors(response, ignoreErrors) {
            var apiNachrichten,
                apiExceptions,
                apiErrors = [];

            response.config = response.config || {};

            if (_.includes([HTTP_STATUS_OK], response.status)) {
                apiNachrichten = getApiNachrichtenFromResponse(response, that.NACHRICHTEN_TYPES.FEHLER.wert);
                apiErrors = getApiNachrichtenAsAlerts(apiNachrichten);
            } else if (_.includes([HTTP_STATUS_BAD_REQUEST_ERROR, HTTP_STATUS_VALIDATION_ERROR, HTTP_STATUS_INTERNAL_SERVER_ERROR], response.status)) {
                if (isApiNachricht(response)) {
                    apiNachrichten = getApiNachrichtenFromResponse(response, that.NACHRICHTEN_TYPES.FEHLER.wert);
                    apiErrors = getApiNachrichtenAsAlerts(apiNachrichten, ignoreErrors);
                } else {
                    apiExceptions = getApiExceptionsFromResponse(response);
                    apiErrors = getApiExceptionsAsAlerts(apiExceptions, ignoreErrors);
                }
            } else if (response.status >= 400 && response.status < 500 && !_.includes(HTTP_STATUS_EXCLUDE_LIST, response.status) && (!response.config.httpErrorsIgnore || (_.isArray(response.config.httpErrorsIgnore) && !_.includes(response.config.httpErrorsIgnore, response.status)))) {
                apiErrors.push(AlertService.create(AppConfig.MESSAGES.unexpected, 'alert'));
            }

            return apiErrors;
        }
        function setRequestTimeout(request, timeout) {
            request.timeout = MiscUtilsService.isEmpty(timeout) ? AppConfig.API.timeout : timeout;
        }
        function isHtmlPage(response) {
            var url = response.config.url;

            return regexIsHtmlPage.test(url);
        }
        function isHttpError(status) {
            return (/^(?!400|401|403|409)(4\d{2}$)/).test(status) || (/^(?!500)(5\d{2}$)/).test(status);
        }
        function isInternalServerError(status) {
            return status === HTTP_STATUS_INTERNAL_SERVER_ERROR;
        }
        function isValidationError(status) {
            return status === HTTP_STATUS_VALIDATION_ERROR;
        }
        function isMaintenance() {
            var $http = $injector.get('$http'),
                cacheId = AppConfig.API.services.checkMaintenance,
                cachedResult = cache.get(cacheId),
                timestamp = moment().unix(),
                promise,
                result;
            if (cachedResult && moment().isBefore(moment.unix(cachedResult.timestamp).add(10, 's'), 'second')) {
                return cachedResult.result;
            }

            cache.remove(cacheId);

            promise = $http({
                method: 'GET',
                url: AppConfig.API.services.checkMaintenance,
                headers: {
                    'Content-Type': 'application/json'
                },
                globalErrorsIgnore: {
                    errors: true,
                    nachrichten: true
                },
                httpErrorsIgnore: true
            }).then(function (response) {
                if (_.get(response, 'data.result.reason') === 'MAINTENANCE') {
                    result = true;
                } else {
                    result = false;
                }

                return result;
            }).catch(function () {
                result = false;

                return result;
            }).finally(function () {
                cache.put(cacheId, {
                    result: $q.when(result),
                    timestamp: timestamp
                });
            });

            cache.put(cacheId, {
                result: promise,
                timestamp: timestamp
            });

            return promise;
        }
    }

    ApiInterceptor.$inject = [
        '$rootScope',
        '$log',
        '$q',
        '$injector',
        'lodash',
        'AppConfig',
        'ApiService'
    ];
    function ApiInterceptor($rootScope, $log, $q, $injector, _, AppConfig, ApiService) {
        var that = this;

        that.request = request;
        that.requestError = requestError;
        that.response = response;
        that.responseError = responseError;
        function request(config) {
            $log.debug('ApiInterceptor request', config);

            ApiService.setRequestTimeout(config, config.timeout);

            return config;
        }
        function requestError(rejection) {
            $log.debug('ApiInterceptor requestError', rejection);

            $rootScope.$emit('iplusjs:createAndAddAlert', {
                message: AppConfig.MESSAGES.unexpected,
                type: 'alert'
            });

            return $q.reject(rejection);
        }
        function response(resp) {
            $log.debug('ApiInterceptor response', resp);

            if (ApiService.isHtmlPage(resp)) {
                return resp;
            }
            if (!_.isArrayBuffer(resp.data) && ApiService.hasErrors(resp)) {
                $rootScope.$emit('iplusjs:addAlert', ApiService.getErrors(resp));

                return $q.reject(resp);
            }

            return resp;
        }
        function responseError(rejection) {
            var NavigationService = $injector.get('NavigationService'),
                ExceptionHandlerService = $injector.get('ExceptionHandlerService'),
                step;

            $log.debug('ApiInterceptor responseError', rejection, NavigationService);

            rejection.config = rejection.config || {};
            if (ApiService.isHtmlPage(rejection)) {
                return $q.reject(rejection);
            }
            if (ApiService.hasErrors(rejection, rejection.config.globalErrorsIgnore)) {
                $rootScope.$emit('iplusjs:addAlert', ApiService.getErrors(rejection));
            } else if (rejection.status === -1 && !rejection.config.unexpectedErrorsIgnore) {
                $rootScope.$emit('iplusjs:createAndAddAlert', {
                    message: AppConfig.MESSAGES.unexpected,
                    type: 'alert'
                });
            }

            if (ApiService.isHttpError(rejection.status) && !rejection.config.httpErrorsIgnore) {
                step = 'fehler.404';
                ApiService.isMaintenance().then(function (isMaintenance) {
                    if (isMaintenance) {
                        step = 'fehler.wartung';
                    }
                }).finally(function () {
                    ExceptionHandlerService.logRemote(rejection, true);

                    return NavigationService.goToStep(step, {
                        reload: false
                    });
                });
            }

            if (ApiService.isValidationError(rejection.status) && rejection.config.showErrorPage) {
                return NavigationService.goToStep('fehler.409', {
                    reload: true
                });
            }

            return $q.reject(rejection);
        }
    }

})();
